module.exports = __webpack_public_path__ + "img/Frame2363.ae674214.png";